// extracted by mini-css-extract-plugin
export default {"ambient":"Ambient_ambient__iYCTb","wander1":"Ambient_wander1__txWqk","wander2":"Ambient_wander2__LWrL6","wander3":"Ambient_wander3__b2nb0"};